import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { priceIntelligenceInstance } from "../../config/axios";
//import arrow from "../../assets/images/pricing/arrow-white.svg";

const ConfidentialityModal = ({ confidentialityModal, setConfidentialityModal, setPiConfidentialityAcceptedAt }) => {
  const [loading, setLoading] = useState(false);
  
  const handleConfirm = async () => {
    try {
      setLoading(true);
      const response = await priceIntelligenceInstance().post("/price/accept-confidentiality");
      if (response?.data?.status === 200) {
        setPiConfidentialityAcceptedAt(response?.data?.confidentialityAcceptedAt);
      }
      setConfidentialityModal(false);
    } catch (e) {
      console.log("error in accept-confidentiality", e);
      setConfidentialityModal(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal show={confidentialityModal} centered className="disclaimer-modal">
        <div className="pricing-disclaimer-content desktop-view-disclaimer-pricing">
          <div className="pricing-disclaimer-text">
            <h1>Confidentiality Notice</h1>
            <p>
              Price Intelligence information is intended solely for internal
              company use and may not be disclosed, distributed, or shared with
              any individuals or entities outside of your organization.
            </p>
          </div>
          <div className="pricing-userlogin-content-btn pricing-disclaimer-btn">
            <Button onClick={handleConfirm} disabled={loading}>
              {loading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <span>Confirm</span>
              )}
              {/* <span>
                <img src={arrow} alt="arrow" />
              </span> */}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ConfidentialityModal;
